// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oena","col":"styles_col__2Zs0g","actions":"styles_actions__2dUXe","conflict":"styles_conflict__HWYB7"};